"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_MIN_WIDTH = 0;
exports.CARD_MIN_WIDTH = 700;
exports.OVERLAPPING_CARD_MIN_WIDTH = 700;
exports.STRIP_CARD_MIN_WIDTH = 700;
exports.STACKED_CARD_MIN_WIDTH = 130;
exports.DEFAULT_ROW_SPAN = 1;
exports.DEFAULT_COLUMN_SPAN = 1;
exports.ROW_GAP = 32;
exports.COLUMN_GAP = 32;
exports.MOBILE_ROW_GAP = 20;
exports.MOBILE_COLUMN_GAP = 20;
//# sourceMappingURL=constants.js.map